// extracted by mini-css-extract-plugin
export var checkMark = "addToCartButton-module--checkMark--3Pb-w";
export var confirmAddToCart = "addToCartButton-module--confirm-add-to-cart--Yvw6x";
export var faCheckCircle = "addToCartButton-module--fa-check-circle--74hqI";